import { ConversionUtil } from "@mcleod/core";
import { LMEGeneralSettings } from "@mcleod/general";
import { AutogenModelDispatchControl, AutogenRowDispatchControl, RowDispatchControlFields } from "./autogen/AutogenModelDispatchControl";

export class ModelDispatchControl extends AutogenModelDispatchControl<RowDispatchControl> {
    constructor() {
        super(RowDispatchControl);
    }
}

export function getDispatchControlBoolean(field: keyof RowDispatchControlFields, valueIfNull: boolean = false): boolean {
    const result = getDispatchControlValue(field);
    if (typeof result === "string")
        return ConversionUtil.parseBoolean(result);
    return result ?? valueIfNull;
}

export function getDispatchControlValue(field: keyof RowDispatchControlFields): any {
    return LMEGeneralSettings.getSingleton().getDispatchControl()[field];
}

export class RowDispatchControl extends AutogenRowDispatchControl {
}
